<template>
  <div>
    <div class="container">
      <h2 class="margin-top-40 margin-bottom-40 text-center">Components showcase</h2>
    </div>
    <div class="sandbox-page container">
      <div class="sandbox-side-bar margin-right-30">
        <router-link
          v-for="item in routes"
          :key="item.to"
          :to="item.to"
          class="font-sans font-size-16 block mb-30 sandbox-page-link"
        >
          {{ item.name }}
        </router-link>
      </div>
      <div class="sandbox-content content">
        <router-view> </router-view>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/sass/base/_vars.scss";
@import "@/assets/sass/base/_mixins.scss";
@import "@/assets/sass/base/_typo.scss";

.sandbox-page {
  display: flex;
}

.sandbox-side-bar {
  background: #fbf9f9;
  border: 1px solid black;
  height: fit-content;

  .sandbox-page-link {
    width: 250px;
    &:not(:last-child) {
      border-bottom: 1px solid black;
    }

    padding: 8px 16px;
    margin-bottom: 0 !important;
    &:hover {
      text-decoration: underline;
    }
    &.router-link-active {
      background: $color-green !important;
    }
  }
}
.sandbox-content {
  background: whitesmoke;
  padding: 30px;
  margin-bottom: 30px;
}
</style>

<script>
export default {
  data() {
    return {
      routes: [
        {
          name: "Text Fields",
          to: "/sandbox/text-field",
        },
        {
          name: "Buttons",
          to: "/sandbox/button",
        },
        {
          name: "Address",
          to: "/sandbox/address",
        },
        {
          name: "Filters",
          to: "/sandbox/filters",
        },
      ],
    };
  },
};
</script>
